import React from 'react';

import { FontAwesomeIcon } from '@schoolinks/ui-components';
import { isFunction } from 'lodash';
import { bool, func, string } from 'prop-types';
import { useCookies } from 'react-cookie';

import { useTranslation } from 'react-i18next';

import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';

import { MenuItem } from '@mui/material';

import {
  GOOGLE_TRANSLATE_COOKIE_KEY,
  GOOGLE_TRANSLATE_COOKIE_DOMAINS,
  DEFAULT_LANGUAGE_ENGLISH,
  GOOGLE_TRANSLATE_COOKIE_OPTIONS,
} from 'components/Common/GoogleTranslateV2/constants';
import useMediaInfo from 'hooks/useMediaInfo';

const shouldShowGoogleTranslate = (reduxState, cookieState) =>
  !!reduxState || !!cookieState;
const LanguageTranslationMenuItem = ({
  className,
  onClickCallback,
  showGoogleTranslate,
  showIcon,
}) => {
  const { isMobile, isDesktop } = useMediaInfo();
  const { i18n } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies();
  const showGoogleTranslateDropdown = shouldShowGoogleTranslate(
    showGoogleTranslate,
    cookies[GOOGLE_TRANSLATE_COOKIE_KEY],
  );

  const handleToggleLanguageTranslation = () => {
    if (isFunction(onClickCallback)) {
      onClickCallback();
    }

    // Only clear out cookies on desktop. Mobile/tablet handle this via language selection drawer
    if (!isDesktop) {
      return;
    }
    if (showGoogleTranslateDropdown) {
      // Remove all googtrans cookies from all domains and paths
      GOOGLE_TRANSLATE_COOKIE_DOMAINS.forEach(domain => {
        // First try with standard options
        removeCookie(GOOGLE_TRANSLATE_COOKIE_KEY, {
          ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
          domain,
        });

        // Also try without expiration
        removeCookie(GOOGLE_TRANSLATE_COOKIE_KEY, {
          path: '/',
          domain,
        });
      });

      // Also try removing without domain)
      removeCookie(GOOGLE_TRANSLATE_COOKIE_KEY, {
        ...GOOGLE_TRANSLATE_COOKIE_OPTIONS,
      });

      i18n.changeLanguage(DEFAULT_LANGUAGE_ENGLISH);
      if (cookies[GOOGLE_TRANSLATE_COOKIE_KEY]) {
        window.location.reload();
      }
    } else {
      i18n.changeLanguage(DEFAULT_LANGUAGE_ENGLISH);
    }
  };
  return (
    <MenuItem className={className} onClick={handleToggleLanguageTranslation}>
      {(isMobile || showIcon) && <FontAwesomeIcon icon={faLanguage} />}
      {showGoogleTranslateDropdown && isDesktop
        ? 'Hide Language Translation'
        : 'Language Translation'}
    </MenuItem>
  );
};

LanguageTranslationMenuItem.propTypes = {
  className: string.isRequired,
  onClickCallback: func.isRequired,
  showGoogleTranslate: bool.isRequired,
  showIcon: bool,
};

LanguageTranslationMenuItem.defaultProps = {
  showIcon: false,
};

export default LanguageTranslationMenuItem;
